import { FontStyleHelper } from '../../../shared/helpers/font-style-helper';
var CalibrationDataToGoModelUtil = /** @class */ (function () {
    function CalibrationDataToGoModelUtil(diagram, goModel) {
        this.diagram = diagram;
        this.goModel = goModel;
    }
    CalibrationDataToGoModelUtil.prototype.saveComponentProperty = function (property, value) {
        this.diagram.model.setDataProperty(this.goModel, property, value);
    };
    CalibrationDataToGoModelUtil.prototype.saveToGoJsModel = function (data) {
        if (data.hasOwnProperty('showPercentage')) {
            this.saveComponentProperty('showPercentage', data.showPercentage);
            if (!data.showPercentage || !data.percentageFont) {
                delete this.goModel.percentageFontStyle;
                delete this.goModel.percentageColor;
                delete this.goModel.percentageIsUnderline;
            }
            else {
                var percentageFontStyle = FontStyleHelper.buildFontStyle(data.percentageFont.isBold, data.percentageFont.isItalic, data.percentageFont.fontSize, data.percentageFont.fontFamily);
                this.saveComponentProperty('percentageFontStyle', percentageFontStyle);
                this.saveComponentProperty('percentageColor', data.percentageFont.color);
                this.saveComponentProperty('percentageIsUnderline', data.percentageFont.isUnderline);
            }
        }
        this.saveComponentProperty('showScale', data.showCalibration);
        if (!data.showCalibration || !data.calibrationMarkDetail) {
            delete this.goModel.masterDivisionNumber;
            delete this.goModel.subDivisionNumber;
            delete this.goModel.calibrationColor;
            delete this.goModel.integerDigits;
            delete this.goModel.fractionDigits;
            delete this.goModel.calibrationDigitFontStyle;
            delete this.goModel.calibrationDigitIsUnderline;
            delete this.goModel.calibrationDigitColor;
            delete this.goModel.showCalibrationDigit;
            return;
        }
        var calibrationDetail = data.calibrationMarkDetail.calibrationDetail;
        if (calibrationDetail) {
            this.saveComponentProperty('masterDivisionNumber', calibrationDetail.masterCalibrations);
            this.saveComponentProperty('subDivisionNumber', calibrationDetail.subCalibrations);
            this.saveComponentProperty('calibrationColor', calibrationDetail.calibrationColor);
        }
        else {
            delete this.goModel.masterDivisionNumber;
            delete this.goModel.subDivisionNumber;
            delete this.goModel.calibrationColor;
        }
        this.saveComponentProperty('showCalibrationDigit', data.calibrationMarkDetail.showCalibrationDigit);
        if (data.calibrationMarkDetail.showCalibrationDigit) {
            var calibrationDigitDetail = data.calibrationMarkDetail.calibrationDigitDetail;
            var calibrationDigitFont = calibrationDigitDetail.calibrationDigitFont;
            var calibrationDigitFontStyle = FontStyleHelper.buildFontStyle(calibrationDigitFont.isBold, calibrationDigitFont.isItalic, calibrationDigitFont.fontSize, calibrationDigitFont.fontFamily);
            this.saveComponentProperty('calibrationDigitFontStyle', calibrationDigitFontStyle);
            this.saveComponentProperty('calibrationDigitColor', calibrationDigitFont.color);
            this.saveComponentProperty('calibrationDigitIsUnderline', calibrationDigitFont.isUnderline);
            this.saveComponentProperty('integerDigits', calibrationDigitDetail.integerDigits);
            this.saveComponentProperty('fractionDigits', calibrationDigitDetail.fractionDigits);
        }
        else {
            delete this.goModel.calibrationDigitFontStyle;
            delete this.goModel.calibrationDigitColor;
            delete this.goModel.calibrationDigitIsUnderline;
            delete this.goModel.integerDigits;
            delete this.goModel.fractionDigits;
        }
    };
    return CalibrationDataToGoModelUtil;
}());
export { CalibrationDataToGoModelUtil };
